<template>
  <div id="app">
    <transition mode="out-in" name="fade">
        <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: "AMTIMSApp",
  data() {
    return {
      // layout: "div"
    }
  }
}
</script>

<style lang="scss">
@import "./styles/base";
#app {
  height: 100%;
  width: 100%;
}
</style>
